import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, retry, tap } from 'rxjs/operators';

import { environment } from './../environments/environment';
import { Logger } from './logger';
import { LoggerService } from './logger.service';
import { ISessionSet } from './roughcheck';

/**
 * Set session state
 */
@Injectable({
  providedIn: 'root'
})
export class SessionSetService {

  // sessionkey = '';
  private SessionSetUrl = environment.apiUrl + 'api/v1/set/';

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    observe: 'response' as const,
    responseType: 'json' as const,
  };

  constructor(
    private http: HttpClient,
    private logger: LoggerService,
  ) { }

  /**
   * Set a session variable
   * @param rref - Roughcheck reference
   * @param aref - Assessment reference
   * @param key - Session key to set
   * @param value - Value to set
   * @param result - SessionSet object
   */
  setSessionKey(
    rref: string,
    aref: string,
    key: string,
    value: string
  ): Observable<any> {
    // this.sessionkey = key;
    // Data to send
    const data: ISessionSet = {
      rref,
      aref,
      key,
      value
    };

    return this.http.post<HttpResponse<any>>(
      this.SessionSetUrl, data, this.httpOptions)
      .pipe(
        catchError(err => this.logger.logError(rref, aref, err))
      );
  }

}

